import { INVOICE_TYPE_ID, CREDIT_MEMO_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { isDate, isContactEmail } from 'customer-data-objects/property/PropertyIdentifier';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
export const isHardcodedReadOnly = (inputProperty, objectTypeId, isEmbedded) => {
  if (objectTypeId === INVOICE_TYPE_ID && inputProperty.name !== 'hubspot_owner_id') {
    return true;
  }
  if (objectTypeId === CREDIT_MEMO_TYPE_ID && inputProperty.name !== 'hubspot_owner_id') {
    return true;
  }
  if (!isEmbedded) {
    return false;
  }
  // when embedded in an iframe, certain inputs (dates + multi email input)
  // don't work great given the constraint on screen size, so we disable them
  return isDate(inputProperty) || isContactEmail(inputProperty, denormalizeTypeId(objectTypeId));
};